


























import { Component, Mixins, Prop, Watch } from 'vue-property-decorator'
import { State, Action } from 'vuex-class'
import { IntlMixin } from 'vuemixins/intl_mixin'
import BaseIcon from 'vuecomponents/base_icon.vue'
import LocaleSelector from 'vuecomponents/locale_selector.vue'

@Component({
  components: {
    BaseIcon,
    LocaleSelector,
  },
})
export default class Dropdown extends Mixins(IntlMixin) {
  @Prop() title!: string
  @Prop() items!: Object[]
  isOpen = false

  openMenu(e) {
    e.stopPropagation()
    this.isOpen = !this.isOpen
  }
}
